/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
/**
 * @description Returns fallback argument if value is null or undefined.
 * @param fallback Fallback value to return if value is null or undefined.
 * @param checkFalsy If true, will return fallback if value is falsy instead of null or undefined.
 */
var valueOrFallback = function valueOrFallback(fallback, _temp) {
  var _ref = _temp === void 0 ? {
      checkFalsy: false
    } : _temp,
    checkFalsy = _ref.checkFalsy;
  return function (value) {
    if (checkFalsy) {
      return value || fallback;
    }
    return value != null ? value : fallback;
  };
};

export { valueOrFallback };
//# sourceMappingURL=value-or-fallback.js.map
